module.exports = __webpack_public_path__ + "static/media/hack_5_bg.88f3e016.jpg";